import { withCache } from '@ngneat/cashew';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { environment } from '@environments/environment';

import { QueryBuilder } from '@cxc/core/builders';

import { Chart } from '@cxc/ui-kit/chart.js/models';

import { API } from '@models/API';

import { platformAPI } from '@services/API/endpoints';

export interface GetChartOptions {
  lender: string;
  reportedAt: string;
  chartName: API.Trusts.Lender.ChartName;
  chartType?: Chart.Type;
  currency?: string;
  loaderOptIn?: boolean | string;
  operations?: string[];
}

@Injectable({
  providedIn: 'root',
})
export class Charts {
  private http = inject(HttpClient);

  public get(options: GetChartOptions) {
    const {
      lender,
      reportedAt,
      chartName,
      chartType = undefined,
      currency = undefined,
      loaderOptIn = true,
      operations = undefined,
    } = options;

    const query = new QueryBuilder();

    query.equals('reported_at', reportedAt).equals('chart', chartName);

    if (currency) {
      query.equals('currency', currency);
    }

    if (chartType) {
      query.equals('type', chartType);
    }

    if (operations) {
      operations.forEach(operation => {
        query.equals('operations', operation.replaceAll('/', '-'));
      });
    }

    return this.http.get<API.Trusts.Lender.Charts.Response>(
      platformAPI.trusts(lender).lender.charts(query),
      {
        headers: new HttpHeaders({
          'Loader-Opt-In': `${loaderOptIn}`,
          'Auth-Opt-In': 'true',
        }),
        context: withCache({
          ttl: environment.CACHE_LIFETIME,
        }),
      }
    );
  }
}
